import Vue from 'vue'
import App from './App.vue'
import './ServiceWorker'
import router from './router'

import $ from "jquery";
window.$ = window.jQuery = $;

import "popper.js";
import "bootstrap";

import NavHeader from '@/components/NavHeader.vue';
import NavFooter from '@/components/NavFooter.vue';

import PageHome from '@/views/Home.vue';
import PageService from '@/views/Service.vue';
//import PageAbout from '@/views/About.vue';
//import PagePortfolio from '@/views/Portfolio.vue';
//import PageBlog from '@/views/Blog.vue';
//import PageSkills from '@/views/Skills.vue';
//import PageContact from '@/views/Contact.vue';

Vue.component('NavHeader', NavHeader)
Vue.component('NavFooter', NavFooter)

Vue.component('PageHome', PageHome)
Vue.component('PageService', PageService)
    //Vue.component('PageAbout', PageAbout)
    //Vue.component('PagePortfolio', PagePortfolio)
    //Vue.component('PageBlog', PageBlog)
    //Vue.component('PageSkills', PageSkills)
    //Vue.component('PageContact', PageContact)

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')